import { useState } from "react";
import { Link } from "react-router-dom";
import OrderAPI from "../../../lib/API/OrderAPI";
import Currencies from "../../../lib/Currencies";

const OrderItemRow = ({ orderId, orderDelivered, item: _item }) => {

  const [item, setItem] = useState(_item);
  const [redeemCodes, setRedeemCodes] = useState(_item.purchases.map((p) => p.redeemCode).join(', '));
  const [collapsed, setCollapsed] = useState(true);

  const requestCode = (productId) => {
    OrderAPI.RequestCode(orderId, productId)
      .then(({ data }) => {
        const newItem = { ...item, purchases : data.purchases };
        setRedeemCodes(newItem.purchases.map((p) => p.redeemCode).join(', '));
        setItem(newItem);
      })
      .catch(() => alert('An error occured, try again later'));
  }

  const toggle = () => {
    setCollapsed(!collapsed);
  }
 
  return (
    <>
      <tr>
        <td colspan="2">
          <div className="d-flex align-items-center">
            <Link to={`/products/${item.variantId}`}><img className="mb-0" src={item.image} alt={item.fullName} /></Link>
            <Link to={`/products/${item.variantId}`}><h6 style={{ flex: 1 }}>{item.name}</h6></Link>
          </div>
        </td>
        <td style={{ width : "100px" }}>
          <p>{item.quantity}</p>
        </td>
        <td style={{ width : "150px" }}>
          <p>{item.price.toFixed(2)} {Currencies.GetSymbol(item.currency)}</p>
        </td>
        <td>
          {orderDelivered &&
            (item.purchases.length != item.quantity && (
              <button style={{ width: 150 }}>
                Request Code
              </button>
            ))}
        </td>
        <td>
          {!orderDelivered && (
            <Link className="btn btn-black" to={`/support?order=${orderId}&productId=${item._id}`}>Report Problem</Link>
          )}
        </td>
      </tr>
    </>
  )
}

export { OrderItemRow };